<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CT">Introduction</h1>
<p class="BOD1">Welcome to <em class="char-style-override-1">Easy Buttercream Cake Designs</em>.</p>
<p class="BOD2">Since I began posting online cake decorating tutorials on my blog Icing Bliss and teaching cake decorating classes, I realized that many people falsely believe that pretty cake decorations are beyond their ability. However, in truth, with a little practice and a few cake decorating tools, beautiful creations are not out of anyone’s reach.</p>
<p class="BOD2">This book features 3 easy buttercream projects, each with detailed step-by-step instructions to assist readers in mastering simple cake decorating techniques and create impressive single-tier cakes for all occasions. Each project demonstrates how to prepare a cake before decorations can be added and features different techniques including creating simple patterns with buttercream. I have chosen the designs to suit beginners who have little or no previous cake decorating experience, but I hope this book will also serve to inspire more experienced cake decorators and act as a design resource.</p>
<p class="BOD2">While the instructions for each project will enable you to reproduce every one of the cakes exactly, I encourage you to adapt the designs and experiment with colours to make your creations unique. If you take the time to also make a few extra decorations while completing each project, you will quickly build up a useful collection of attractive decorations that you can use another day on other bakes such as cookies or cupcakes.</p>
<p class="BOD2">Although I have included some staple recipes, this book was intended to focus on sugarcraft rather than baking. Acknowledging that a lot of people don’t have the time or the patience to bake cakes and just want to focus on decorating, there is no shame in using store-bought sponges or plain cakes from supermarkets for these projects.</p>
<p class="BOD2">I hope that you enjoy the projects in this book and will feel inspired to use the techniques learned in your future cake endeavours.</p>
<p class="BOD2">Happy Cake Crafting!</p>
<p class="BOD2">Fiona</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?47f817a8